<template>
	<b-card>
		<form @submit.prevent="getPlaces">
			<input
				name="text"
				v-model="text"
				v-validate="'required'"
				:class="{'form-control': true, 'is-invalid': errors.has('text')}"
				type="text"
			/>
		</form>
	</b-card>
</template>

<script>
	import axios from 'axios'

	export default {
		data() {
			return {
				text: '',
			}
		},

		methods: {
			async getPlaces() {

				const isValid = await this.$validator.validateAll()

				if (!isValid) return

				const {data} = axios.post('/google/places', {text: this.text})

				console.log(data)
			},
		},
	}
</script>

<style lang="scss" scoped>
</style>
